export class LegalEntity {
    legalEntityId: number;
    legalEntityDesc: string;
    legalEntityTypeCode: string;
    countryCode: string;
}
